import type { ParticipantRow } from "./types";
import { useData } from "./useData";
import { useUser } from "./useUser";

export interface RowState {
  rows?: ParticipantRow[];
  error?: unknown;
  loading: boolean;
  myRow?: string;
}

export function useRow(): RowState {
  const { rows, error, loading } = useData();
  const { user } = useUser();

  return {
    rows,
    error,
    loading,
    myRow: findParticipantRow(rows, user)?.row,
  };
}

export function findParticipantRow(
  rows: ParticipantRow[] = [],
  user?: string,
): ParticipantRow | undefined {
  return rows.filter((row) => row.name === user)[0];
}
